import React, { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { useToastContext } from "../../context/ToastContext";
import hubspotLogo from "../../assets/hubspot/hubspot_orange.png";

const HubSpotSuccessPage: React.FC = () => {
  const { showToast } = useToastContext();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    showToast("success", "HubSpot successfully connected!");
  }, [showToast]);

  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-background-default dark:bg-background-dark px-4 sm:px-6 -mt-8 sm:-mt-12">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center text-center space-y-8 py-6">
          <div className="space-y-6">
            <div className="relative">
              <div className="p-6 bg-white dark:bg-background-paperDark rounded-3xl shadow-sm border border-black/5 dark:border-divider-dark">
                <img
                  src={hubspotLogo}
                  alt="HubSpot"
                  className="h-14 w-auto object-contain"
                />
              </div>
              <div className="absolute -bottom-2 -right-2">
                <div className="relative">
                  <div className="absolute inset-0 bg-green-500/20 dark:bg-green-400/20 rounded-full animate-ping"></div>
                  <div className="relative bg-white dark:bg-background-paperDark rounded-full p-1.5 shadow-md border border-black/5 dark:border-divider-dark">
                    <CheckCircle
                      className="w-6 h-6 text-green-500 dark:text-green-400"
                      strokeWidth={2.5}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4 max-w-sm">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-black dark:text-text-primaryDark mb-2">
                You're all set!
              </h1>
              <p className="text-base text-text-secondary dark:text-text-secondaryDark leading-relaxed">
                HubSpot is now connected. Your agent will listen for deals in
                specific stages to accurately track and manage your pipeline.
              </p>
            </div>
          </div>

          <div className="pt-4 w-full max-w-xs">
            <button
              onClick={() => navigate("/")}
              className="w-full px-6 py-3.5 bg-[#FF7A59] hover:bg-[#E86A4A] dark:bg-[#FF7A59] dark:hover:bg-[#E86A4A] text-white rounded-lg font-medium text-sm transition-all duration-200 shadow-sm hover:shadow-md active:scale-[0.98]"
            >
              Go to Agent Directory
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubSpotSuccessPage;
